import TimerDecorator from './TimerDecorator';

/*
Concrete decorator for timer at session level
    This is WIP.
*/
class TimerSession extends TimerDecorator {
    constructor(countdown) {
        super(countdown);
    }

    startTimer() {
        super.startTimer();
    }

    stopTimer() {
        super.stopTimer();
    }

    resetTimer() {
        super.resetTimer();
    }
}

export default TimerSession;